// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__9V1CD"};